import { useEffect, useRef } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Mounts once at the top of the app and reports every public page-view
 * to the backend. Admin routes (and api paths) are excluded server-side too.
 */
export default function PageViewTracker() {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    const path = location.pathname + (location.search || "");
    if (path === lastPath.current) return;
    lastPath.current = path;
    if (path.startsWith("/admin")) return;
    axios.post(`${API}/track/pageview`, { path }).catch(() => {});
  }, [location.pathname, location.search]);

  return null;
}
